import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, inject, ViewChild, TemplateRef } from "@angular/core";
import { CommonModule, AsyncPipe } from '@angular/common';
import { Auftrag } from '../Api/DcoApi/Auftraege'
import { AuftragCard } from './Controlls/AuftragCard'
import { FormsModule } from '@angular/forms';
import { DateSelect } from './Controlls/DateSelect'
import { OffcanvasComponent } from "./Controlls/offcanvas.component";
import { GrundSelect } from "./Controlls/SearchAndSelect/GruendeSelect";
import { KooperationspartnerSelect } from "./Controlls/SearchAndSelect/KooperationspartnerSelect";
import { SeriennummerSelect } from "./Controlls/SearchAndSelect/SeriennummerSelect";
import { RestClient } from "../Api/DcoApi/Client/RestClient";
import { PflegegruppeSelect } from "./Controlls/PflegegruppeSelect";
import { ToastService } from "./Services/Toasts/ToastService";
import { Geraet } from "../Api/DcoApi/AktenEintraege/Geraet";
import { StatusPipe } from "../Pipes/StatusPipe";
import { IsSpezialUserDirective, IsWelcomeCallDirective } from "../Admin/AdminGuard";
import {ConfirmDialog} from './Popups/ConfirmDialog';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
  imports: [
    CommonModule,
    AuftragCard,
    FormsModule,
    DateSelect,
    OffcanvasComponent, GrundSelect, KooperationspartnerSelect, SeriennummerSelect, PflegegruppeSelect, StatusPipe, IsWelcomeCallDirective, IsSpezialUserDirective
  ],
  selector: 'Akte-Vertrag',
  templateUrl: './Akte.Vertrag.html',
  styleUrl: './Akte.Vertrag.css'
})
export class Akte_Vertrag implements OnChanges {
  @Input() Auftrag: Auftrag | null = null;
  @Input() VersicherungsNr: string | null |undefined = null;
  @Output() AuftragChange = new EventEmitter<Auftrag | null>();

  Client: RestClient = new RestClient();
  toastService: ToastService;
  private modalService = inject(NgbModal);
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService);
  }

  get ShowPG51(): boolean {
    return this.Auftrag?.pflegegruppe == 51 || this.Auftrag?.pflegegruppe == 54
  }

  get ShowPG52(): boolean {
    return this.Auftrag?.pflegegruppe == 52
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.Auftrag);
    if (changes['Auftrag']) {

      this.cdr.detectChanges();
    }
  }
  async UpdateOrder() {
    if(this.Auftrag != null)
      if(this.Auftrag.geraet != null && this.Auftrag.geraet.seriennummer !== undefined &&  this.Auftrag.geraet.key != 1511 && this.Auftrag.geraet.seriennummer != null && this.Auftrag?.status < 900 && ((this.Auftrag.ruekholung?.abgeschlossen && this.Auftrag.ruekholung?.abgeschlossen != null)
      || (this.Auftrag.ekv?.abgelehnt?.zeitpunkt  && this.Auftrag.ekv?.abgelehnt?.zeitpunkt != null)
          || (this.Auftrag.beendigung?.widerruf?.zeitpunkt && this.Auftrag.beendigung?.widerruf?.zeitpunkt != null)
          || (this.Auftrag.beendigung?.storno?.zeitpunkt && this.Auftrag.beendigung?.storno?.zeitpunkt != null)
      ))
        this.AskBevoreSaveMessage();
      else
        await this.SendUpdate();
  }

  async SendUpdate()
  {
    if (this.Auftrag != null) {
      try {
        this.Auftrag = await this.Client.Put<Auftrag, Auftrag>(`/Backend/Api/V2/Akte/${this.VersicherungsNr}/Auftrag/Update`, this.Auftrag);
        this.AuftragChange.emit(this.Auftrag);
        this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
      }
      catch (error)
      {
        this.toastService.show({ template: this.errorTpl, classname: 'bg-danger text-light show', delay: 10000 })
        return;
      }

    }
  }

  AskBevoreSaveMessage()
  {
    var modal = this.modalService.open(ConfirmDialog);
    modal.update({ size: 'Dialog' });
    modal.componentInstance.Text = "Achtung: Diesem Kunden ist bereits ein Gerät zugewiesen. Wenn Sie jetzt speichern, wird das aktuelle Gerät abgemeldet und freigegeben – die bestehende Versorgung wird dadurch beendet. Möchten Sie wirklich fortfahren?";
    modal.closed.subscribe(async b => {
      if (b ) {
        await this.SendUpdate();
      }
    });
  }

  async KALClieck() {
    if (this.Auftrag && this.Auftrag != null && this.Auftrag.wellcomeCall && this.Auftrag.wellcomeCall != null) {

      this.Auftrag.wellcomeCall.anzahlVersucheWellcomecall++;
      this.Auftrag.wellcomeCall.letzterVersucheWellcomecall = new Date();
      this.UpdateOrder();
    }
  }

  async setBestaetigt() {
    if (this.Auftrag && this.Auftrag != null && this.Auftrag.leitstelle && this.Auftrag.leitstelle != null) {

      this.Auftrag.leitstelle.bestaetigt = new Date();
      this.UpdateOrder();
    }
  }

  geraetChneged(geraet: Geraet | null) {
    if (this.Auftrag && geraet) {
      this.Auftrag.geraet = geraet;
    }
  }

  get CanSetUnterschriftErvolgt(): boolean {
    if (!this.Auftrag || this.Auftrag == null)
      return false;

    return this.Auftrag.abrechnung?.unterschriftErfolgt == true || ((this.Auftrag.abrechnung.inbetriebnahme !== undefined && this.Auftrag.abrechnung.inbetriebnahme != null) &&
      (this.Auftrag.geraet !== undefined && this.Auftrag.geraet != null && this.Auftrag.geraet.seriennummer !== undefined && this.Auftrag.geraet.seriennummer != null && this.Auftrag.geraet.seriennummer !== '')
      && (this.Auftrag.genehmigung !== undefined && this.Auftrag.genehmigung != null && this.Auftrag.genehmigung.genehmigungsnummer !== undefined && this.Auftrag.genehmigung.genehmigungsnummer != null && this.Auftrag.genehmigung.genehmigungsnummer !== '')
      && (this.Auftrag.genehmigung.genehmigungsDatum !== undefined && this.Auftrag.genehmigung.genehmigungsDatum != null)
      && (this.Auftrag.dateien?.findIndex(o => o.typ == 1) > -1 || (this.Auftrag.dateien?.findIndex(o => o.typ == 15) > -1 && this.Auftrag.kooperationspartner.key == 11) )
    );
  }

  get CanSetSerial(): boolean {
    if (!this.Auftrag || this.Auftrag == null)
      return false;

    return (this.Auftrag.geraet != null  && this.Auftrag.geraet.seriennummer !== undefined && this.Auftrag.geraet.seriennummer != null && this.Auftrag.geraet.seriennummer  != '')|| ((this.Auftrag.genehmigung.genehmigungsDatum !== undefined && this.Auftrag.genehmigung.genehmigungsDatum != null) &&
      (this.Auftrag.genehmigung.genehmigungsnummer !== undefined && this.Auftrag.genehmigung.genehmigungsnummer != null && this.Auftrag.genehmigung.genehmigungsnummer != ''))
  }

  get CanSetWeellcomeCall(): boolean {
    if (!this.Auftrag || this.Auftrag == null)
      return false;

    return (this.Auftrag.genehmigung.genehmigungsDatum != null  && this.Auftrag.genehmigung.genehmigungsnummer !== undefined && this.Auftrag.genehmigung.genehmigungsnummer != null && this.Auftrag.genehmigung.genehmigungsnummer  != '')
  }

  async SendMip() {
    await this.Client.Get(`/MipTest/${this.Auftrag?.key}`);
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
  @ViewChild('errorTpl') public errorTpl!: TemplateRef<any>;
}
